import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/d519d3c6-15e0-4246-b346-a0337b559f79";
export const REGISTER_URL = "https://a.ntrk2.com/39e5c249-f11a-456c-b084-64b028276f63";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://gowinmx.loadprkw2a.com/download?openExternalBrowser=1&id=ys2fckepifz7fw0";

export * from "./codes";
export * from "./context";
